export function getBackgroundImages(node) {
    const images = node.getAttribute('data-background-images');
    const response = {
        desktopImage: null,
        mobileImage: null,
        backgroundSize: node.style.backgroundSize,
        backgroundPosition: node.style.backgroundPosition,
        backgroundAttachment: node.style.backgroundAttachment,
        backgroundRepeat: node.style.backgroundRepeat || 'repeat'
    };

    if (images) {
        const imagesStructure = JSON.parse(images.replace(/\\"/g, '"'));
        if (imagesStructure.desktop_image) {
            response.desktopImage = imagesStructure.desktop_image;
        }
        if (imagesStructure.mobile_image) {
            response.mobileImage = imagesStructure.mobile_image;
        }
    }

    return response;
}

const alignmentToFlex = {
    top: 'flex-start',
    middle: 'center',
    bottom: 'flex-end'
};

export function getVerticalAlignment(node) {
    let verticalAlignment = null;
    if (node.style.justifyContent) {
        verticalAlignment = flexToVerticalAlignment(node.style.justifyContent);
    }

    return {
        verticalAlignment
    };
}

export function verticalAlignmentToFlex(alignment) {
    return alignmentToFlex[alignment];
}

export function flexToVerticalAlignment(flex) {
    const flexToAlignment = Object.assign(
        {},
        ...Object.entries(alignmentToFlex).map(([a, b]) => ({ [b]: a }))
    );
    return flexToAlignment[flex];
}

export function getAdvanced(node) {
    return {
        ...getPadding(node),
        ...getMargin(node),
        ...getBorder(node),
        ...getTextAlign(node),
        ...getCssClasses(node),
        ...getIsHidden(node)
    };
}

export function getPadding(node) {
    return {
        paddingTop: node.style.paddingTop,
        paddingRight: node.style.paddingRight,
        paddingBottom: node.style.paddingBottom,
        paddingLeft: node.style.paddingLeft
    };
}

export function getMargin(node) {
    return {
        marginTop: node.style.marginTop,
        marginRight: node.style.marginRight,
        marginBottom: node.style.marginBottom,
        marginLeft: node.style.marginLeft
    };
}

export function getBorder(node) {
    return {
        border: node.style.borderStyle,
        borderColor: node.style.borderColor,
        borderWidth: node.style.borderWidth,
        borderRadius: node.style.borderRadius
    };
}

export function getTextAlign(node) {
    return {
        textAlign: node.style.textAlign
    };
}

export function getCssClasses(node) {
    return {
        cssClasses: node.getAttribute('class')
            ? node.getAttribute('class').split(' ')
            : []
    };
}

export function getIsHidden(node) {
    return {
        isHidden: node.style.display === 'none'
    };
}

export function cssToJSXStyle(style) {
    const toCamelCase = str => str.replace(/-(.)/g, (_, p) => p.toUpperCase());
    const result = {};
    style.split(';').forEach(el => {
        const [prop, value] = el.split(':');
        if (prop) {
            result[toCamelCase(prop.trim())] = value.trim();
        }
    });

    return result;
}

export function getMediaQueries(node) {
    const response = [];
    const dataset = Object.keys(node.dataset);

    const medias = dataset
        .filter(key => key.match(/media-/))
        .map(key => node.dataset[key]);

    const styles = dataset
        .filter(key => key.match(/mediaStyle/))
        .map(key => node.dataset[key]);

    medias.forEach((media, i) => {
        response.push({
            media,
            style: cssToJSXStyle(styles[i])
        });
    });

    return { mediaQueries: response };
}
